// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__sPXm6","logo":"Sidebar_logo__Dw4F4","nav":"Sidebar_nav__LMFH2","active":"Sidebar_active__OebGr","logoutBtn":"Sidebar_logoutBtn__IlgOD"};